






















































































































import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { Component } from 'vue-property-decorator';
import { MswAppTitle }  from '@/shared/msw-app-title';
import UUIFComponents from '@/shared/uuifComponent';
import { InfoState, SetHelpContentIdPayload } from '../../core/core.store';
import { SelectOption, SwSelect } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import SharedAccordian from './components/sharedAccordian.vue';
import CatalogUnit from './components/catalog-unit.vue';
import { Mutation, State } from 'vuex-class';
import * as decode from 'jwt-decode';
import { RootStoreState } from '../../store/store';
import { currentUserKey } from '@/shared/msw-constants';
import CasApplicationSelectDialog from './components/cas-application-selection-dialog.vue';
import { tooltip } from '@libs-uuif/shared/tooltip-dir';
import { VuexMappedMutation } from '@sonicwall/unified-ui-framework/src/shared/common-types';
const cssPrefix = 'catalogComponent';
@Component({
  components: {
    MswAppTitle,
    ...UUIFComponents,
    SwSelect,
    SharedAccordian,
    CatalogUnit,
    CasApplicationSelectDialog,
  },
  directives: {
    tooltip,
  },
})
export default class CatalogComponent  extends SwExtendedVue {
  cssPrefix = cssPrefix;

  partNumberSearch: string = '';
  prevServiceid: string = '';

  selectedProductFamily: string = 'productFamily';
  selectedProductName: string = 'productName';
  // customised
  customizedDescription: string = '';
  customizedServiceName: string = '';
  customizedServiceCount: string = '';

  productCatagoryList: any[] = [];
  productFamilyList: any[] = [];
  serviceList: any[] = [];
  productLineList: any[] = [];
  // customised
  customizedServiceList: any[] = [];

  isReadOnlyAccess: boolean = false;
  // for guest
  showPricingChange: boolean = false;
  isGetTenant: boolean = false;
  // for HES Flow
  showProductGroupSelectDialog: boolean = false;

  showCasApplicationSelectDialog: boolean = false;

  pendingProduct: any = {};

  @State((state: RootStoreState) => state.CatalogStoreModule.mode)
  readonly mode: string;

  @State((state: RootStoreState) => state.CatalogStoreModule.serviceTypes)
  readonly serviceTypes: any[];

  @State((state: RootStoreState) => state.CatalogStoreModule.rootServiceId)
  readonly rootServiceId: any;

  @State((state: RootStoreState) => state.CatalogStoreModule.isguestaddedtocart)
  readonly isguestaddedtocart: boolean;

  @State((state: RootStoreState) => state.CatalogStoreModule.isguestbuynow)
  readonly isguestbuynow: boolean;

  @State((state: RootStoreState) => state.CatalogStoreModule.serialNumber)
  readonly serialnumber: string;

  @State((state: RootStoreState) => state.CatalogStoreModule.friendlyName)
  readonly friendlyname: string;

  @State((state: RootStoreState) => state.CatalogStoreModule.ssipn)
  readonly ssipn: string;

  @State((state: RootStoreState) => state.CatalogStoreModule.serviceId)
  readonly serviceid: string;

  @State((state: RootStoreState) => state.CatalogStoreModule.isFromHES)
  readonly isFromHES: boolean;

  @Mutation
  setHelpContentId: VuexMappedMutation<SetHelpContentIdPayload>;

  get getproductFamilyList() {
    const temp: SelectOption[] = [];
    // tslint:disable-next-line:no-unused
    this.productFamilyList &&
    this.productFamilyList.length > 0 &&
    this.productFamilyList.forEach((productFamily: any) => {
      temp.push({
        id: productFamily.value,
        label: productFamily.label,
        value: productFamily.value,
      });
    });
    temp.push({
      id: 'productFamily',
      label: this.$t('catalog.productFamily')
      .toString(),
      value:'productFamily',
    });
    return temp;
  }

  get getproductLineList() {
    const temp: SelectOption[] = [];
    // tslint:disable-next-line:no-unused
    this.productLineList &&
    this.productLineList.length > 0 &&
    this.productLineList.forEach((productLine: any) => {
      temp.push({
        id: productLine.value,
        label: productLine.label,
        value: productLine.value,
      });
    });
    temp.push({
      id: 'productName',
      label:  this.$t('catalog.productName')
      .toString(),
      value:'productName',
    });
    return temp;
  }

  get isShowSerialNumber() {
    return (this.$route.query.serialNumber || this.$route.query.SERIALNUMBER || this.$route.query.serialnumber) ? true : false;
  }

  get getAccordianValues(): { serviceName: string, desc: string, count: string, list: any[], expandStatus: boolean }[] {
    let temp: { serviceName: string, desc: string, count: string, list: any[], expandStatus: boolean  }[] = [];
    if (this.mode === 'customized') {
      temp = this.customizedServiceList && this.customizedServiceList.length > 0 ? [{
        serviceName: this.customizedServiceName,
        desc: this.customizedDescription,
        count: this.customizedServiceCount,
        list: this.customizedServiceList,
        expandStatus: true,
      }] : [];
    } else {
      const tempServiceTypes = this.$store.getters['CatalogStoreModule/getServiceTypes'] ?
        [...this.$store.getters['CatalogStoreModule/getServiceTypes']]
        : [];
      temp = tempServiceTypes && tempServiceTypes.length > 0 ? [...tempServiceTypes] : [];
    }
    return temp;
  }
  get getAccordianStyles() {
    return {
      headerPadding: '10px',
      headerFontSize: '16px',
    };
  }

  setHelpId(value:string) {
    const temp:string[] = [];
    temp.push(value);
    this.setHelpContentId({ helpId:temp });
  }

  created() {
    this.setPricingChange();
    this.checkQueryParamsAndSaveInStore();
  }

  setPricingChange() {
    if (localStorage.getItem('showPricingChange')) {
      if (localStorage.getItem('showPricingChange') === 'YES') {
        this.showPricingChange =  true;
      } else {
        this.showPricingChange = false;
      }
    }
  }

  checkQueryParamsAndSaveInStore() {
    const params = this.$router.currentRoute.query;
    if (params) {
      const serialnumber: string = (this.convertToString(params, 'serialNumber') ||  this.convertToString(params, 'SERIALNUMBER') || this.convertToString(params, 'serialnumber')) || '';
      const friendlyname: string = (this.convertToString(params, 'friendlyName') || this.convertToString(params, 'friendlyname') || this.convertToString(params, 'FRIENDLYNAME')) || '';
      const isFromHES: boolean = (this.convertToString(params, 'isFromHES')) ? true : false;
      const ssipn: string = (this.convertToString(params, 'ssipn')) || '';
      const serviceid: string = (this.convertToString(params, 'serviceId') || this.convertToString(params, 'SERVICEID') || this.convertToString(params, 'serviceid')) || '';
      const isguestbuynow: boolean = (this.convertToString(params, 'isGuestBuynow') === 'TRUE') || false;

      serviceid && this.storeValuesToStore({ property: 'rootServiceId', with: serviceid || '' });
      serviceid && this.storeValuesToStore({ property: 'serviceId', with: serviceid || '' });
      serialnumber && this.storeValuesToStore({ property: 'serialNumber', with: serialnumber || '' });
      isFromHES && this.storeValuesToStore({ property: 'isFromHes', with: isFromHES });
      isguestbuynow && this.storeValuesToStore({ property: 'isguestbuynow', with: isguestbuynow });
      friendlyname && this.storeValuesToStore({ property: 'friendlyName', with: friendlyname });
      ssipn && this.storeValuesToStore({ property: 'ssipn', with: ssipn });

      if (params && (this.convertToString(params, 'isGuestBuynow') === 'TRUE')) {
        this.$store.dispatch('CatalogStoreModule/changeCartCount', 0);
        this.$store.commit('mutate', { property:'cartCount', with: 0 });
      }

      if (params && this.convertToString(params, 'SOR') ||
        params && this.convertToString(params, 'sor')) {
        this.$store.dispatch('removeUserInfo');
        this.storeValuesToStore({ property: 'isguestbuynow', with: true });
      }
    }
  }

  mounted() {
    this.setHelpId('catalog');
    this.fetchServices();
  }

  fetchServices() {
    if (this.isFromHES) {
      this.fromHESPage();
    } else {
      if (this.serviceid !== '' && this.serialnumber !== '') {
        this.$store.commit('CatalogStoreModule/mutate', { property: 'mode', with: 'customized' });
        this.getServiceList();
      } else {
        this.$store.commit('CatalogStoreModule/mutate', { property: 'mode', with: 'default' });
        this.getProductCatalog();
      }
    }
  }

  destroyed() {
    this.setHelpId('default');
    this.storeValuesToStore({ property: 'serviceTypes', with: [] });
    this.storeValuesToStore({ property: 'serialNumber', with: '' });
    this.storeValuesToStore({ property: 'serviceId', with: '' });
    this.storeValuesToStore({ property: 'rootServiceId', with: '' });
    this.storeValuesToStore({ property: 'mode', with: 'default' });
    this.storeValuesToStore({ property: 'isFromHES', with: false });
    this.storeValuesToStore({ property: 'ssipn', with: '' });
    this.storeValuesToStore({ property: 'friendlyName', with: '' });
  }

  convertToString(params: any, value: string) {
    return params[value] ? params[value].toString() : '';
  }

  storeValuesToStore(value: any) {
    this.$store.commit('CatalogStoreModule/mutate', value);
  }

  fromHESPage () {
    const request = {
      isFromHES : true,
      serviceId : this.serviceid,
      friendlyName : this.friendlyname,
      serialNumber:  this.serialnumber,
      ssipn : this.ssipn,
    };
    this.$store.dispatch('CatalogStoreModule/getServiceListForHES', request)
      .then((response: any) => {
        this.serviceList = response.content.buyableServiceNames || [];
        this.isReadOnlyAccess = response.content.isReadOnlyAccess ? response.content.isReadOnlyAccess : false;
        if (this.serviceList.length > 0) {
          this.isGetTenant = response.content.buyableServiceNames[0].arrbuyableoptions[0].isGetTenant || false;
          this.customizeServiceList();
        }
        if (this.isLoggedIn()) {
          this.pendingProduct = sessionStorage.getItem('productAddedBeforeLogin') ?
            sessionStorage.getItem('productAddedBeforeLogin') :
            {};
          if (this.pendingProduct) {
            if (this.serialnumber === '' && this.isGetTenant) {
              this.pendingProduct.SerialNumber = this.$store.getters.getUserId;
              this.showProductGroupSelectDialog = true;
            } else {
              this.addToCart(this.pendingProduct);
            }
            sessionStorage.removeItem('productAddedBeforeLogin');
          }
        }
      })
      .catch((errorResponse: any) => {
        this.$store.commit('stopLoading');
        const message: InfoState = { infoType: 'high', infoMsg: errorResponse.msgDesc ? errorResponse.msgDesc :  'Operation is unsuccesful' };
        this.$store.commit('displayMessage', message);
      });
  }

  getServiceList() {
    const request = {
      serviceId: this.partNumberSearch ? '' : this.serviceid,
      productName: '',
      serialNumber: this.serialnumber || '',
      ssipn: this.partNumberSearch || '',
      equoteid: '',
      isguestbuynow: this.isguestbuynow || false,
    };
    this.$store.dispatch('CatalogStoreModule/getServiceList', request)
      .then((response: any) => {
        if (response.content.token !== undefined) {
          const value: any = response.content.token || '';
          const decodedResponse: any = (value && decode(value)) || {};
          const res:any = {
            msgCode: '',
            msgDesc: '',
            content: {
              deviceCode: '',
              defaultApplication: '',
              isFreeTrial: '',
              userName: decodedResponse?.userName,
              emailAddress: decodedResponse?.email,
              givenName: decodedResponse?.givenName,
              token: response?.content?.token,
              sId: decodedResponse.sId,
              TFA: 'OFF',
              roles: decodedResponse.roles?.split(','),
              showRegisterPopup: '',
              spogUser: '',
            },
            showRememberMe: '',
          };
          decodedResponse.isLargeCustomer === 'YES' ? localStorage.setItem('isLargeCustomer', 'YES') : localStorage.setItem('isLargeCustomer', 'NO');
          this.$store.dispatch('preserveUserInfo', res);
        }
        this.getProductCatalog();
        if (response.msgCode  && response.msgCode === 'MSWAPP:GETSERVICESSUCCESS') {
          this.serviceList = response.content.hasOwnProperty('buyableServiceNames') ? response.content.buyableServiceNames : [];
          this.isReadOnlyAccess = response.content.isReadOnlyAccess ? response.content.isReadOnlyAccess : false;
          this.customizeServiceList();
          this.$store.commit('stopLoading');
        } else {
          this.$store.commit('stopLoading');
          const message: InfoState = { infoType: 'high', infoMsg: response.msgDesc ? response.msgDesc :  'Operation is unsuccesful' };
          this.$store.commit('displayMessage', message);
        }
      })
      .catch((errorResponse: any) => {
        this.$store.commit('stopLoading');
        this.getProductCatalog();
        const message: InfoState = { infoType: 'high', infoMsg: errorResponse.msgDesc ? errorResponse.msgDesc :  'Operation is unsuccesful' };
        this.$store.commit('displayMessage', message);
      });
  }
  getProductCatalog() {
    this.$store.dispatch('CatalogStoreModule/getProductCatalog')
      .then((response: any) => {
        if (response.msgCode === 'MSWAPP:PRODUCTCATALOGSUCCESS') {
          this.$store.commit('stopLoading');
          this.productCatagoryList = response.hasOwnProperty('content') ?
                                     response.content.hasOwnProperty('productCatagoryList') ?
                                     response.content.productCatagoryList : [] : [];
          this.productCatagoryList.forEach((catagory: any) => {
            const blacklist = "'CDP Series','GX Series','IBR','SGMS','SSL Series','Scrutinizer Software','ViewPoint Software'";
            if (catagory.level === '0' && blacklist.indexOf(catagory.productName) <= 0) {
              this.productFamilyList.push({
                label: catagory.productName,
                value: catagory.productCatagoryId,
              });
            }
          });
        } else {
          this.$store.commit('stopLoading');
          const message: InfoState = { infoType: 'high', infoMsg: response.msgDesc ? response.msgDesc :  'Operation is unsuccesful' };
          this.$store.commit('displayMessage', message);
        }
      })
      .catch((errorResponse: any) => {
        this.$store.commit('stopLoading');
        const message: InfoState = { infoType: 'high', infoMsg: errorResponse.msgDesc ? errorResponse.msgDesc :  'Operation is unsuccesful' };
        this.$store.commit('displayMessage', message);
      });
  }
  // tslint:disable-next-line:no-unused
  customizeServiceList(expandService: any = {}) {
    this.customizedServiceList = [];
    this.customizedServiceList = [...this.serviceList[0].arrbuyableoptions];
    this.customizedServiceList.forEach((element: any) => {
      element.quantity = '1';
      if (element.bisdynamiccount) {
        element.nodecount = element.minnodecount;
        element.users = element.minnodecount;
      } else {
        element.users = 1;
      }
      element.autoRenewalValue = true;
      element.currexpdate = this.serviceList[0].hasOwnProperty('currexpdate') ? this.serviceList[0].currexpdate : '';
      element.curnodecount = this.serviceList[0].hasOwnProperty('curnodecount') ? this.serviceList[0].curnodecount : 0;
      if (this.serialnumber !== '' && this.serialnumber !== undefined && element.buyableProjections !== undefined && element.buyableProjections.length) {
        element.buyableProjectionsRadio = (element.buyableProjections[0].optiontype === undefined ? false : true);
        element.buyableProjectionsSelectedValue = element.buyableProjections[0].optiontype;
        element.statusText = element.buyableProjections[0].buyableStatus.statusText;
      }
    });
    if (expandService && expandService.serviceId && expandService.serviceId !== '') {
      this.serviceTypes.forEach((element: any) => {
        if (element.serviceId !== expandService.serviceId) {
          this.$store.dispatch('CatalogStoreModule/updateServiceType', {
            rootServiceId: element.serviceId,
            property: 'expandStatus',
            with: [false],
          })
          .then(() => { this.$store.commit('stopLoading');  });
        }
      });
      this.serviceTypes.forEach((element: any) => {
        if (element.serviceId === expandService.serviceId) {
          const description = this.serviceList[0].serviceDescription ? this.serviceList[0].serviceDescription : '';
          this.$store.dispatch('CatalogStoreModule/updateServiceType', {
            rootServiceId: expandService.serviceId,
            property: 'desc',
            with: [description],
          })
          .then(() => { this.$store.commit('stopLoading');  });
          this.$store.dispatch('CatalogStoreModule/updateServiceType', {
            rootServiceId: expandService.serviceId,
            property: 'list',
            with:  this.customizedServiceList ? [[...this.customizedServiceList]] : [],
          })
          .then(() => { this.$store.commit('stopLoading');  });
          this.$store.dispatch('CatalogStoreModule/updateServiceType', {
            rootServiceId: expandService.serviceId,
            property: 'expandStatus',
            with: [true],
          })
          .then(() => { this.$store.commit('stopLoading');  });
        }
      });
      this.prevServiceid = expandService.serviceId;
    } else {
      this.customizedDescription = this.serviceList[0].hasOwnProperty('serviceDescription') ? this.serviceList[0].serviceDescription : '';
      this.customizedServiceName = this.serviceList[0].hasOwnProperty('serviceFamily') ? this.serviceList[0].serviceFamily : '';
      this.customizedServiceCount = this.serviceList[0].hasOwnProperty('arrbuyableoptions') ? this.serviceList[0].arrbuyableoptions.length.toString() : '0';
      this.storeValuesToStore({ property: 'rootServiceId', with: this.serviceList[0].serviceId || '' });
      this.$store.commit('CatalogStoreModule/updateServiceTypes', {
        rootServiceId: this.serviceList[0].hasOwnProperty('serviceId') ? this.serviceList[0].serviceId : '0',
        property: 'ALL',
        with: [{
          currexpdate: '',
          isGetTenant: this.isGetTenant,
          isHesSku: this.isFromHES,
          serviceId: this.serviceList[0].hasOwnProperty('serviceId') ? this.serviceList[0].serviceId : '0',
          serviceName: this.customizedServiceName,
          desc: this.customizedDescription,
          count: this.customizedServiceCount,
          list: this.customizedServiceList,
          expandStatus: true,
        }],
      });
    }
  }
  populateProductLine() {
    this.$store.commit('CatalogStoreModule/mutate', { property: 'mode', with: 'default' });
    this.partNumberSearch = '';
    this.selectedProductName = 'productName';
    this.productLineList = [];
    this.serviceList = [];
    this.$store.dispatch('CatalogStoreModule/updateServiceType', {
      rootServiceId: '',
      property: 'ALL',
      with: [],
    })
    .then(() => { this.$store.commit('stopLoading');  });
    this.productCatagoryList.forEach((catagory: any) => {
      if (catagory.level === '1' && catagory.parentProductCategoryId === this.selectedProductFamily) {
        this.productLineList.push({
          label: catagory.productName,
          value: catagory.productCatagoryId,
        });
      }
    });
  }
  getServiceTypes() {
    this.selectedProductName !== 'productName' &&
      this.$store.dispatch('CatalogStoreModule/getServiceTypes', this.selectedProductName)
      .then((response: any) => {
        if (response.operationStatus === 'OK') {
          this.$store.commit('stopLoading');
          this.serviceList = [];
          let tempServiceTypes = response.hasOwnProperty('content') ?
                              response.content.hasOwnProperty('productCatServicesTypeList') ?  response.content.productCatServicesTypeList : [] : [];
          tempServiceTypes = tempServiceTypes.map((serviceType: any) => {
            return {
              ...serviceType,
              serviceName: serviceType.hasOwnProperty('userServiceFamily') ? serviceType.userServiceFamily : '',
              desc: '',
              count: serviceType.hasOwnProperty('serviceCount') ? serviceType.serviceCount : 0,
              list: [],
              expandStatus: false,
            };
          });
          this.$store.dispatch('CatalogStoreModule/updateServiceType', {
            rootServiceId: '',
            property: 'ALL',
            with: [...tempServiceTypes],
          })
          .then(() => { this.$store.commit('stopLoading');  });
        } else {
          this.$store.commit('stopLoading');
          const message: InfoState = { infoType: 'high', infoMsg: response.msgDesc ? response.msgDesc :  'Operation is unsuccesful' };
          this.$store.commit('displayMessage', message);
        }
      })
      .catch((errResponse: any) => {
        this.$store.commit('stopLoading');
        const message: InfoState = { infoType: 'high', infoMsg: errResponse.msgDesc ? errResponse.msgDesc :  'Operation is unsuccesful' };
        this.$store.commit('displayMessage', message);
      });
  }
  onExpandAccordian(service: any) {
    if (this.mode === 'default' && service.list && service.list.length === 0) {
      const request = {
        serviceId: service.serviceId,
        productName: this.selectedProductName,
        serialNumber: '',
        ssipn: '',
        equoteid: '',
        isguestbuynow: this.isguestbuynow,
      };
      this.$store.dispatch('CatalogStoreModule/getServiceList', request)
        .then((response: any) => {
          if (response.msgCode === 'MSWAPP:GETSERVICESSUCCESS') {
            this.serviceList = response.content.hasOwnProperty('buyableServiceNames') ? response.content.buyableServiceNames : [];
            this.isReadOnlyAccess = response.content.isReadOnlyAccess ? response.content.isReadOnlyAccess : false;
            this.customizeServiceList(service);
            this.$store.commit('stopLoading');
          } else {
            this.$store.commit('stopLoading');
            this.serviceTypes.forEach((element: any) => {
              if (element.serviceId !== service.serviceId) {
                this.$store.dispatch('CatalogStoreModule/updateServiceType', {
                  rootServiceId: element.serviceId,
                  property: 'expandStatus',
                  with: [false],
                })
                .then(() => { this.$store.commit('stopLoading');  });
              }
            });
            const message: InfoState = { infoType: 'high', infoMsg: response.msgDesc ? response.msgDesc :  'Operation is unsuccesful' };
            this.$store.commit('displayMessage', message);
          }
        })
        .catch((errorResponse: any) => {
          this.$store.commit('stopLoading');
          const message: InfoState = { infoType: 'high', infoMsg: errorResponse.msgDesc ? errorResponse.msgDesc :  'Operation is unsuccesful' };
          this.$store.commit('displayMessage', message);
        });
    }
  }

  getServicesBySsipn() {
    this.$store.commit('CatalogStoreModule/mutate', { property: 'mode', with: 'customized' });
    if (this.serialnumber !== '') {
      this.getServiceList();
    } else {
      const request = {
        serviceId: '',
        productName: '',
        serialNumber: '',
        ssipn: this.partNumberSearch ? this.partNumberSearch.trim() : '',
        equoteid: '',
        isguestbuynow: this.isguestbuynow,
      };
      this.$store.dispatch('CatalogStoreModule/getServiceList', request)
        .then((response: any) => {
          this.customizedServiceList = [];
          this.$store.dispatch('CatalogStoreModule/updateServiceType', {
            rootServiceId: '',
            property: 'ALL',
            with: [],
          })
          .then(() => { this.$store.commit('stopLoading');  });
          this.selectedProductFamily = 'productFamily';
          this.selectedProductName = 'productName';
          this.storeValuesToStore({ property: 'serialNumber', with: '' });
          this.serviceList = [];
          if (response.msgCode === 'MSWAPP:GETSERVICESSUCCESS') {
            this.serviceList = response.content.hasOwnProperty('buyableServiceNames') ? response.content.buyableServiceNames : [];
            this.isReadOnlyAccess = response.content.isReadOnlyAccess ? response.content.isReadOnlyAccess : false;
            this.customizeServiceList();
            this.$store.commit('stopLoading');
          } else {
            this.$store.commit('stopLoading');
            const message: InfoState = { infoType: 'failed', infoMsg: response.msgDesc ? response.msgDesc :  'Operation is unsuccesful' };
            this.$store.commit('displayMessage', message);
          }
        })
        .catch((errorResponse: any) => {
          this.$store.commit('stopLoading');
          const message: InfoState = { infoType: 'failed', infoMsg: errorResponse.msgDesc ? errorResponse.msgDesc :  'Operation is unsuccesful' };
          this.$store.commit('displayMessage', message);
        });
    }
  }
  addToCart(requestData: any) {
    this.$store.dispatch('CatalogStoreModule/addToCart', requestData)
      .then((response: any) => {
        this.$store.commit('stopLoading');
        if (response.operationStatus === 'OK') {
          if (response.msgCode === 'MSWAPP:NEEDCASBAPPLICATION') {
            this.showCasApplicationSelectDialog = true;
          } else {
            this.$store.dispatch('CatalogStoreModule/changeCartCount', response.content.cartCount || 0);
            if (this.isguestbuynow) {
              this.storeValuesToStore({ property: 'isguestaddedtocart', with: true });
            }
            const message: InfoState = { infoType: 'success', infoMsg: response.msgDesc ? response.msgDesc :  'Operation is succesful' };
            this.$store.commit('displayMessage', message);
            if (this.isFromHES) {
              this.$router.push('cart');
            }
          }
        } else {
          this.$store.commit('stopLoading');
          const message: InfoState = { infoType: 'high', infoMsg: response.msgDesc ? response.msgDesc :  'Operation is unsuccesful' };
          this.$store.commit('displayMessage', message);
        }
      })
      .catch((errResponse: any) => {
        this.$store.commit('stopLoading');
        const message: InfoState = { infoType: 'high', infoMsg: errResponse.msgDesc ? errResponse.msgDesc :  'Operation is unsuccesful' };
        this.$store.commit('displayMessage', message);
      });
  }
  isLoggedIn(): boolean {
    if (this.$store.getters.getUserId &&
        this.$store.getters.getUserId.toUpperCase() === 'GUESTBUYNOW') {
      return true;
    }
    return (localStorage.getItem(currentUserKey) &&
            this.$store.getters.getUserInfo &&
            this.$store.getters.getUserInfo.token &&
            this.$store.getters.getUserInfo.sessionId) ?
            true :
            false;
  }
  closeProductGroupDialog(result: any) {
    if (result && result !== null && result !== undefined) {
      this.pendingProduct.tenantID = result.productGroupId || result.partyGroupId;
      this.checkHesPresence(this.pendingProduct);
    } else {
      this.pendingProduct = {};
    }
    this.showProductGroupSelectDialog = false;
  }
  checkHesPresence(requestData: any) {
    this.$store.dispatch('CatalogStoreModule/checkHesPresence', requestData.tenantID)
      .then((response: any) => {
        this.$store.commit('stopLoading');
        if (response.content &&
            response.content.hasOwnProperty('isValid') &&
            response.content.isValid) {
          this.addToCart(requestData);
        } else {
          this.$store.commit('stopLoading');
          const message: InfoState = { infoType: 'high', infoMsg: response.msgDesc ? response.msgDesc :  'Operation is unsuccesful' };
          this.$store.commit('displayMessage', message);
        }
      })
      .catch((errorResponse: any) => {
        this.$store.commit('stopLoading');
        const message: InfoState = { infoType: 'high', infoMsg: errorResponse.msgDesc ? errorResponse.msgDesc :  'Operation is unsuccesful' };
        this.$store.commit('displayMessage', message);
      });
  }
  onRefreshPage() {
    if (this.partNumberSearch && this.partNumberSearch.trim() !== '') {
      this.getServicesBySsipn();
    } else {
      this.getServiceTypes();
    }
  }
  closeCasApplicationSelectDialog(result: any) {
    if (result && result !== null && result !== undefined) {
      this.pendingProduct.casbAppid = result;
      this.addToCartWithCAS(this.pendingProduct);
    } else {
      this.pendingProduct = {};
    }
    this.showCasApplicationSelectDialog = false;
  }
  addToCartWithCAS(requestData : any) {
    this.$store.dispatch('CatalogStoreModule/addToCart', requestData)
      .then((response: any) => {
        this.$store.commit('stopLoading');
        if (response.operationStatus === 'OK') {
          this.$store.dispatch('CatalogStoreModule/changeCartCount', response.content.cartCount || 0);
          const message: InfoState = { infoType: 'success', infoMsg: response.msgDesc ? response.msgDesc :  'Operation is succesful' };
          this.$store.commit('displayMessage', message);
        } else {
          const message: InfoState = { infoType: 'high', infoMsg: response.msgDesc ? response.msgDesc :  'Operation is unsuccesful' };
          this.$store.commit('displayMessage', message);
        }
      })
      .catch((errResponse: any) => {
        this.$store.commit('stopLoading');
        const message: InfoState = { infoType: 'high', infoMsg: errResponse.msgDesc ? errResponse.msgDesc :  'Operation is unsuccesful' };
        this.$store.commit('displayMessage', message);
      });
  }
}
